import React, { useState, useEffect } from 'react';
import { configApi } from '@/api';
import { errorHandlingGlobal } from '@/utils/helper';

interface InitialConfig {
  loading: boolean;
  midtransClientKey: string;
}

const useSetInitialConfig: () => InitialConfig = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [midtransClientKey, setMidtransClientKey] = useState<string>('');
  const setThemeClassForBody = () => {
    const body = document.body || document.querySelector('body');
    const query = new URLSearchParams(window.location.search);
    const theme = query.get('theme_name');
    if (theme) {
      body.classList.add(`themed-${theme}`);
    } else {
      body.classList.add(`themed-lifepack`);
    }
  };
  const initData = async () => {
    setThemeClassForBody();
    try {
      setLoading(true);
      const { data } = await configApi.getConfigMidtrans();
      setMidtransClientKey(data.midtrans.client_id);
      setLoading(false);
      return;
    } catch (error) {
      errorHandlingGlobal(error);
    }
  };
  useEffect(() => {
    initData();
  }, []);

  return {
    loading,
    midtransClientKey,
  };
};

export default useSetInitialConfig;
